import React from 'react';
import { Menu, Item } from 'react-contexify';
import { useTranslation } from 'react-i18next';

import openDomain from '../../utils/openDomain';

function VisitWebsiteContextMenu({ id, disabled }) {
  const { t } = useTranslation('sonar');

  const handleOpenWebsite = ({ props: { domain } }) => {
    openDomain(domain);
  };

  return (
    <Menu id={id} animation='scale'>
      <Item onClick={handleOpenWebsite} disabled={disabled}>
        {t('visitWebsite')}
      </Item>
    </Menu>
  );
}

export default VisitWebsiteContextMenu;
